export default class UsersSelector {
  public static selectUser(state: ReduxState) {
    return state.user.data;
  }
}
